import { Coffee } from "lucide-react";
import { Button } from "@/components/ui/button";

export const DonateButton = ({ variant = "default", size = "default", className = "" }) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => window.open('https://ko-fi.com/narrativescout', '_blank')}
      className={`bg-cyan-600 hover:bg-cyan-700 text-white font-mono ${className}`}
    >
      <Coffee className="w-4 h-4 mr-2" />
      DONATE
    </Button>
  );
};

